﻿$(function () {
    $('div[data-slideshow=true]').each(function (index, element) {
        element = $(element);
        var width = element.width();
        var height = element.height();
        var id = element.attr('data-slideshowname');

        var showPagination = element.attr('data-pagination') === "true";

        var description = $($('#slide' + id).find('img')[0]).attr('alt');
        $(element.children('.slidesdescription')[0]).html(description);

        var imgCount = $('#slide' + id).find('img').length;

        $('#slide' + id).slidesjs({
            width: width,
            height: height,
            navigation: false,
            pagination: {
                active: showPagination,
                effect: 'fade'
            },
            effect: {
                fade: {
                    speed: 400
                }
            },
            play: {
                active: false,
                auto: true,
                interval: 4000,
                swap: true,
                effect: 'fade'
            },
            callback: {
                start: function (number) {
                    if (number == imgCount) {
                        number = 0;
                    }

                    description = $($('#slide' + id).find('img')[number]).attr('alt');
                    $(element.children('.slidesdescription')[0]).html(description);
                }
            }
        });
    });
});